{
  "roles": {
    "copyLinePermission": "Kopírování v řádku",
    "copyPermission": "Kopírování",
    "createLinePermission": "Tvoření v řádku",
    "createPermission": "Tvoření",
    "deletePermission": "Smazání",
    "editLinePermission": "Editace v řádku",
    "editPermission": "Editace",
    "exportPermission": "Export tabulky",
    "title": "Helios"
  },
  "recordDetail": {
    "entry": "Položka detail",
    "recordNotFound": "Záznam nebyl nalezen.",
    "template": {
      "description": "Popis šablony:",
      "status": "Stav:",
      "name": "Název šablony:",
      "created": "Vytvořeno:"
    }
  },
  "templates": {
    "prefilters": {
      "codeListItem": "Hodnota z číselníku",
      "templateItem": "Hodnota ze šablony"
    },
    "conditions": {
      "actionsTitle": "Akce",
      "actions": {
        "Edit": "Editace",
        "EditInRow": "Editace v řádku",
        "Delete": "Smazání",
        "Create": "Tvoření",
        "CreateInRow": "Tvoření v řádku",
        "Copy": "Kopírování",
        "CopyInRow": "Kopírování v řádku",
        "Presave": "Předuložení",
        "ContinuousSave": "Průběžné uložení",
        "AutomaticValue": "Automatická hodnota"
      },
      "automaticValueSettings": "Nastavení automatické hodnoty",
      "targetItem": "Cílová položka",
      "defaultValue": "Výchozí hodnota",
      "saveCondition": "Uložit podmínku",
      "condition": {
        "leftBracket": "Levá závorka",
        "rightBracket": "Pravá závorka",
        "and": "A",
        "or": "Nebo",
        "source": "Zdroj",
        "static": "Statická hodnota",
        "value": "Hodnota",
        "empty": "Prázdné",
        "comparisonOperator": "Operátor porovnání",
        "comparisons": {
          "GreaterThan": "Větší než",
          "GreaterThanOrEqual": "Větší nebo rovno",
          "LessThan": "Menší než",
          "LessThanOrEqual": "Menší nebo rovno",
          "Empty": "Prázdné",
          "NotEmpty": "Není prázdné",
          "Null": "Null",
          "NotNull": "Není null",
          "Equals": "Rovná se",
          "NotEquals": "Nerovná se",
          "Contains": "Obsahuje",
          "NotContains": "Neobsahuje",
          "Between": "Mezi",
          "DaysBefore": "Dní před datem"
        },
        "selectValue": "Vyberte hodnotu",
        "roles": "Role",
        "roleTags": "Štítky rolí",
        "pickRole": "Konkrétní role…",
        "pickRoleTag": "Štítek role…",
        "daysBefore": {
          "label": "Počet dní předem",
          "error": "Zadejte celé číslo 0–3650",
          "sourceError": "Zdroj musí být datumové pole"
        }
      },
      "sources": {
        "HeliosUser": "Helios uživatel",
        "HeliosUserId": "Helios uživatel ID",
        "UserReference": "Uživatelská reference",
        "UserRole": "Role uživatele",
        "UserEmail": "Email uživatele",
        "ContactEmail": "Kontaktní email uživatele",
        "DateTimeNow": "Datum a čas nyní",
        "DateNow": "Datum nyní"
      },
      "states": {
        "Visible": "Viditelnost",
        "Editable": "Editovatelnost",
        "DefaultValue": "Výchozí hodnota",
        "AutomaticValue": "Automatická hodnota",
        "Highlight": "Zvýraznění",
        "Collapsed": "Sbalení sekce",
        "Required": "Povinnost vyplnění"
      },
      "parentRecordRef": {
        "parentRecordRelationItemId": "Atribut z nadřazeného záznamu",
        "parentRecordRelationItemIdHelper": "Vyberte atribut z nadřazeného záznamu pro předvyplnění tohoto pole"
      },
      "toasts": {
        "errors": {
          "delete": "Chyba při mazání podmínky",
          "add": "Chyba při přidávání podmínky",
          "edit": "Chyba při úpravě podmínky",
          "stateChanged": "Chyba při změně stavu podmínky"
        },
        "success": {
          "delete": "Podmínka byla úspěšně smazána",
          "add": "Podmínka byla úspěšně přidána",
          "edit": "Podmínka byla úspěšně upravena",
          "stateChanged": "Stav podmínky byl úspěšně změněn"
        }
      }
    },
    "notifications": {
      "notificationsTitle": "Nastavení",
      "notificationTemplate": "Notifikační šablona",
      "isTaskNotification": "Je úkolová notifikace",
      "resolvesTask": "Řeší úkol",
      "setParametersMapping": "Mapování parametrů",
      "functions": "Funkce",
      "functionsOverview": "Funkce přehledu",
      "functionsDetail": "Funkce detailu",
      "addFunction": "Přidat",
      "functionsSelection": "Výběr funkcí",
      "parameter": "Parametr",
      "dataItem": "Sloupec"
    },
    "invalidDetailTemplateId": "Neplatné ID detailové šablony",
    "dataModel": {
      "alias": "Nápověda možných aliasů",
      "button": "Aplikovat SQL dotaz",
      "label": "SQL dotaz",
      "placeholder": "Zde můžete napsat SQL dotaz",
      "success": "SQL dotaz byl úspěšně aktualizován",
      "title": "Nastavení datového modelu"
    },
    "forms": {
      "buttons": {
        "aggregationGroupItems": "Agregační skupiny",
        "buttonItems": "Funkce",
        "columnValueItems": "Hodnoty sloupců",
        "externalItems": "Externí záznam",
        "userDefinedItems": "Uživatelsky definovaná pole",
        "delimiters": "Oddělovače",
        "infoText": "Informační text",
        "infoTextItems": "Informační texty",
        "horizontalSolidDelimiter": "Horizontální plná čára",
        "verticalSolidDelimiter": "Vertikální plná čára",
        "horizontalDashedDelimiter": "Horizontální čárkovaná čára",
        "verticalDashedDelimiter": "Vertikální čárkovaná čára",
        "horizontalDottedDelimiter": "Horizontální tečkovaná čára",
        "verticalDottedDelimiter": "Vertikální tečkovaná čára"
      },
      "globalSettings": "Globální nastavení",
      "hasMobileLayout": "Má mobilní rozložení",
      "hasWebLayout": "Má webové rozložení",
      "copyWebToMobile": "Kopírovat z webu",
      "copyWebToMobileConfirm": "Opravdu chcete zkopírovat rozložení z webu? Tímto přepíšete aktuální mobilní rozložení.",
      "editTab": "Upravit záložku",
      "deleteTab": "Smazat záložku",
      "deleteTabConfirm": "Smazat tuto záložku? Sekce se přesunou na jinou záložku. Duplicitní názvy a odpovídající překlady budou přejmenovány.",
      "editSubTab": "Upravit podsekci",
      "deleteSubTab": "Smazat podsekci",
      "deleteSubTabConfirm": "Opravdu chcete smazat tuto podsekci? Všechny položky v této podsekci budou odstraněny.",
      "subTabUnnamedHint": "Tato podsekce nemá název. Klikněte na ikonu menu a pojmenujte ji.",
      "collapseConditions": {
        "title": "Podmínky sbalení sekce",
        "tooltip": "Podmínky sbalení",
        "ruleName": "Název pravidla",
        "addRule": "Přidat pravidlo"
      },
      "item": {
        "basicSettings": {
          "basicInformation": "Základní informace",
          "displayType": {
            "label": "Typ zobrazení",
            "value": "Hodnota",
            "staticselection": "Statický výběr",
            "browse": "Výběr z číselníku",
            "file": "Soubor",
            "link": "Odkaz",
            "button": "Tlačítko",
            "calendarname": "Název kalendáře",
            "calendarcategory": "Kategorie kalendáře",
            "calendardatefrom": "Datum kalendáře od",
            "calendardateto": "Datum kalendáře do",
            "calendarallday": "Celodenní kalendář",
            "infotext": "Informační text"
          },
          "sorting": "Řazení",
          "properties": "Vlastnosti",
          "advancedOptions": "Pokročilé možnosti",
          "buttonLabel": "Jméno tlačítka",
          "disableTriggerEvents": "Editovat bez instanční logiky",
          "ordinalIndex": "Pořadí zpracování",
          "isPresaveAllowed": "Povolit předukládání",
          "showButtonDirectly": "Zobrazit přímo na řádku",
          "label": "Jméno",
          "sortOrder": "Pořadí řazení",
          "sortType": {
            "label": "Typ řazení",
            "none": "Žádné",
            "ascending": "Vzestupně",
            "descending": "Sestupně"
          },
          "title": "Základní údaje"
        },
        "aggregation": {
          "title": "Agregace přehledu",
          "isGrouped": "Seskupovat",
          "groupingOrder": "Pořadí seskupení",
          "aggregationType": "Vypočítat jako",
          "groupedTooltip": "U prvku je nastaveno seskupení / agregace"
        },
        "formatting": {
          "alignment": "Zarovnání",
          "specificFormatting": "Specifické formátování",
          "align": {
            "center": "Na střed",
            "left": "Vlevo",
            "right": "Vpravo"
          },
          "dateTime": {
            "date": "Datum",
            "datetime": "Datum a čas",
            "label": "Formát data",
            "monthYear": "Měsíc / rok",
            "time": "Čas"
          },
          "labelAlign": "Zarovnání popisku",
          "mathRound": {
            "arithmetic": "Aritmetické",
            "down": "Dolů",
            "label": "Matematické zaokrouhlení",
            "up": "Nahoru"
          },
          "maxValue": "Maximální hodnota",
          "minValue": "Minimální hodnota",
          "minGreaterThanMax": "Minimální hodnota nesmí být větší než maximální hodnota",
          "roundTo": {
            "tenthousandths": "Zaokrouhlení na nejbližší desetitisíciny",
            "thousandths": "Zaokrouhlení na nejbližší tisíciny",
            "hundredths": "Zaokrouhlení na nejbližší setiny",
            "tenths": "Zaokrouhlení na nejbližší desetiny",
            "dozens": "Zaokrouhlení na nejbližší desítky",
            "hundreds": "Zaokrouhlení na nejbližší stovky",
            "thousands": "Zaokrouhlení na nejbližší tisíce",
            "label": "Zaokrouhlit na"
          },
          "separator": {
            "none": "Žádný",
            "comma": "Čárka",
            "dot": "Tečka",
            "label": "Oddělovač tisíců",
            "space": "Mezera"
          },
          "showAsTime": "Zobrazit jako čas",
          "showAsTextArea": "Zobrazit jako textovou oblast",
          "showPhoneOrMail": "Zobrazit jako telefon nebo email",
          "showWebLink": "Zobrazit jako webový odkaz",
          "showAsRichText": "Zobrazit jako Rich Text",
          "specialChars": "Speciální znaky",
          "title": "Formátování",
          "unit": "Jednotka",
          "valueAlign": "Zarovnání hodnoty",
          "buttonAlign": "Zarovnání tlačítka",
          "labelLayout": {
            "label": "Rozložení popisku",
            "sideBySide": "Vedle sebe",
            "stacked": "Pod sebou"
          }
        },
        "settings": {
          "dynamicRelations": "Dynamické vztahy",
          "fileFolder": "Pořadač pro soubory",
          "targetTemplate": "Cílová šablona",
          "browse": {
            "dataSources": "Zdroje dat",
            "columnConfiguration": "Konfigurace sloupců",
            "advancedOptions": "Pokročilé možnosti",
            "filtering": "Filtrování",
            "conditions": "Podmínky",
            "allowMultipleSelection": "Povolit více výběrů",
            "displayColumns": "Zobrazované sloupce",
            "displayColumnsHelp": "Přetáhněte sloupce pro změnu jejich pořadí",
            "valueColumn": "Sloupec hodnoty",
            "allowMultipleSelectionHint": "Více výběrů je možné pouze při nastaveném dynamickém vztahu",
            "codeListTemplate": "Číselníková šablona",
            "detailTemplate": "Detailová šablona",
            "dynamicRelation": "Dynamický vztah",
            "entryTemplate": "Položková šablona"
          },
          "file": {
            "folder": "Pořadač",
            "viewMode": "Režim zobrazení",
            "viewModeTitle": "Režim zobrazení příloh",
            "viewModeIcons": "Velké ikony",
            "viewModeCompact": "Kompaktní seznam"
          },
          "staticSelection": {
            "title": "Statické možnosti",
            "key": "V databázi",
            "value": "Zobrazit jako"
          },
          "infoText": {
            "content": "Obsah (rich text)",
            "title": "Informační text",
            "empty": "K dispozici není žádný obsah",
            "emptyHint": "Zatím nevyplněno",
            "filled": "vyplněno",
            "copyToAll": "Kopírovat do všech jazyků",
            "edit": "Upravit obsah"
          },
          "title": "Nastavení"
        }
      },
      "saveSuccess": "Formulář byl úspěšně uložen",
      "inheritedHighlightConditionName": "Podmínka zvýraznění",
      "inheritedVisibilityConditionName": "Podmínka viditelnosti",
      "warning": {
        "removeItem": "Opravdu chcete odstranit položku?",
        "tabNameExists": "Tento název záložky již existuje"
      }
    },
    "functions": {
      "button": {
        "add": "Přidat funkci",
        "orderButtons": "Nastavit pořadí tlačítek"
      },
      "orderButtonsModal": {
        "title": "Nastavit pořadí tlačítek",
        "description": "Přetažením funkcí nastavíte pořadí tlačítek.",
        "toasts": {
          "success": "Pořadí tlačítek bylo uloženo"
        }
      },
      "selectDetailTemplateModal": {
        "title": "Vyberte detail šablony"
      },
      "selectFunctionModal": { "title": "Vyberte funkci" },
      "addFunctionModal": {
        "allowMultipleSelection": "Povolit spuštění nad více záznamy",
        "requiresSaveBeforeExecution": "Vyžadovat uložení před spuštěním",
        "showAsStandaloneButton": "Zobrazit jako samostatné tlačítko",
        "showAsStandaloneButtonDisabledBecauseItIsCommon": "Obecné funkce jsou vždy zobrazeny jako samostatné tlačítko.",
        "requiresConfirmation": "Vyžadovat potvrzení při spuštění",
        "openCreatedRecord": "Otevřít vytvořený záznam",
        "openCreatedRecordTemplateId": "Šablona pro otevření záznamu",
        "title": "Přidat funkci",
        "titleUpdate": "Upravit funkci",
        "functionName": "Název funkce",
        "tooltip": "Štítek",
        "aliasPc": "Alias PC",
        "aliasMobile": "Alias Mobile",
        "iconPc": "Ikona PC",
        "iconMobile": "Ikona Mobile",
        "colorPc": "Barva PC",
        "colorMobile": "Barva Mobile",
        "addParameter": "Přidat parametr",
        "parameters": "Parametry",
        "displayConditions": "Podmínky zobrazení",
        "displayConfiguration": "Konfigurace zobrazení",
        "pcVersion": "PC VERZE",
        "mobileVersion": "MOBILNÍ VERZE",
        "syncFromPc": "Synchronizovat z PC",
        "behaviorAndConditions": "Chování a podmínky",
        "toasts": {
          "syncSuccess": "Nastavení PC bylo zkopírováno do mobilní verze"
        },
        "conditions": {
          "title": "Podmínky zobrazení funkce",
          "setName": "Název sady podmínek",
          "setDescription": "Popis"
        }
      },
      "triggerFunctionModal": {
        "title": "Spustit funkci",
        "comment": "Komentář",
        "success": "Funkce byla úspěšně spuštěna",
        "error": "Nastala chyba při spouštění funkce"
      },
      "confirmFunctionModal": {
        "title": "Potvrdit akci",
        "text": "Chcete spusti funkci {{name}}?"
      },
      "parameterModal": {
        "titleAdd": "Přidat parametr",
        "titleEdit": "Upravit parametr",
        "titleView": "Zobrazit parametr",
        "name": "Název",
        "labelText": "Štítek",
        "type": "Typ",
        "order": "Pořadí",
        "isRequired": "Povinný",
        "isMultiSelect": "Umožnit výběr více záznamů",
        "templateBrowseId": "Číselníková šablona",
        "prefilter": {
          "title": "Podmínky předfiltrování",
          "conditions": "Podmínky",
          "updated": "Podmínky předfiltrování aktualizovány",
          "addPrefilter": "Přidat podmínku",
          "condition": "Podmínka {{index}}",
          "description": "Při výběru hodnoty se v číselníku zobrazí pouze záznamy splňující všechny podmínky.",
          "empty": "Zatím žádné podmínky — číselník se zobrazí nefiltrovaný."
        },
        "options": "Možnosti",
        "addOption": "Přidat možnost",
        "optionKey": "Název",
        "optionValue": "Hodnota",
        "toasts": {
          "success": {
            "add": "Parametr byl úspěšně přidán",
            "edit": "Parametr byl úspěšně upraven"
          }
        }
      }
    },
    "printConfigurations": {
      "title": "Přidat tiskovou šablonu",
      "reportId": "ID tiskové šablony",
      "name": "Název tisku",
      "description": "Popis",
      "order": "Pořadí",
      "active": "Aktivní",
      "add": "Přidat konfiguraci tisku",
      "edit": "Upravit konfiguraci tisku",
      "sections": {
        "basic": "Základní údaje",
        "output": "Výstup",
        "reportDefinition": "Definice sestavy",
        "filter": "Filtr přehledové sestavy",
        "arguments": "Argumenty sestavy"
      },
      "target": "Cíl tisku",
      "targets": {
        "file": "Soubor",
        "printer": "Tiskárna"
      },
      "fileFormat": "Formát souboru",
      "printerName": "Název tiskárny",
      "copiesNumber": "Počet kopií",
      "folderId": "Číslo pořadače",
      "fileName": "Název souboru na serveru",
      "returnFileContent": "Vrátit obsah souboru",
      "reportType": "Typ sestavy",
      "reportTypes": {
        "form": "Formulář",
        "browse": "Přehled",
        "pureBrowse": "Přehled bez filtrace"
      },
      "reportName": "Název sestavy",
      "libraryName": "Název knihovny",
      "classId": "Číslo třídy",
      "filterFolderId": "Pořadač filtru",
      "filterId": "Číslo filtru",
      "argumentName": "Název argumentu",
      "argumentValue": "Hodnota",
      "argumentSkip": "Přeskočit",
      "addArgument": "Přidat argument",
      "notSet": "Nenastaveno (výchozí)",
      "tooltips": {
        "title": "Tiskové šablony",
        "noPrintConfigurations": "Žádné tiskové konfigurace",
        "selectRecordsToPrint": "Vyberte záznamy pro tisk",
        "printSuccess": "Tisková operace byla úspěšně dokončena",
        "reportId": "Číslo tiskové sestavy v Heliu",
        "target": "Cíl tisku – soubor nebo tiskárna",
        "fileFormat": "Formát souboru, pokud je zvolen tisk do souboru",
        "printerName": "Název tiskárny, pokud je zvolen tisk na tiskárnu",
        "copiesNumber": "Počet kopií. Použije se pouze při tisku na tiskárnu, při exportu do souboru se ignoruje",
        "fileName": "Plný název souboru na serveru při tisku do souboru. Pokud je zapnuto „Vrátit obsah souboru“, nemusí být zadán – použije se dočasný soubor na serveru",
        "folderId": "Číslo pořadače, pokud je vybrána přehledová (nikoliv formulářová) sestava",
        "returnFileContent": "Zda se při tisku do souboru vrátí obsah souboru (pole bajtů)",
        "reportType": "Druh sestavy – formulářová, přehledová s filtrováním, nebo přehledová bez filtrování (vytisknou se všechna data dle selektu, neaplikují se permanentní filtry ani práva)",
        "reportName": "Název sestavy definované v knihovně",
        "libraryName": "Název knihovny, ve které je sestava definována",
        "classId": "Číslo třídy",
        "filterFolderId": "Číslo pořadače filtru",
        "filterId": "Číslo filtru",
        "argumentName": "Název parametru",
        "argumentValue": "Hodnota parametru",
        "argumentSkip": "Přeskočit argument při zpracování argumentů filtru"
      }
    },
    "settings": {
      "dataSource": "Datový zdroj",
      "device": {
        "label": "Zařízení",
        "mobile": "Mobil",
        "web": "Web",
        "webAndMobile": "Web i mobil"
      },
      "displayAs": "Zobrazit jako",
      "name": "Interní název šablony",
      "heg": {
        "label": "Třída a pořadač",
        "classes": "Třída",
        "folders": "Pořadač"
      },
      "module": "Modul",
      "selectModuleModal": { "title": "Vyberte modul" },
      "selectDataSourceModal": { "title": "Vyberte datový zdroj" },
      "selectTableModal": { "title": "Vyberte tabulku" },
      "order": "Pořadí šablony",
      "related": {
        "button": "+ Přidat nadřazenou šablonu",
        "columns": {
          "label": "Spojovací sloupce",
          "modal": {
            "title": "Spojovací sloupce",
            "linkColumn": "Spojovací sloupec ({{type}})"
          }
        },
        "label": "Nadřazená šablona",
        "modal": {
          "title": "Vybrat nadřazenou šablonu",
          "template": "Vybrat nadřazenou šablonu",
          "type": "Vybrat typ nadřazenej šablony"
        }
      },
      "table": "Tabulka",
      "template": "Šablona",
      "type": {
        "api": "API číselník",
        "calendar": "Kalendář",
        "codelist": "Číselník",
        "detail": "Detail",
        "entry": "Položka",
        "label": "Typ šablony",
        "overview": "Přehled"
      },
      "visibility": "Viditelnost"
    },
    "templateImport": "Import šablony",
    "templateCopy": "Kopírování šablony",
    "copyDisabledTooltip": "Pro kopírování šablony vyberte prosím přesně jednu šablonu ze seznamu.",
    "templateCopySuccess": "Šablona byla úspěšně zkopírována",
    "deleteTemplateModal": {
      "title": "Smazat šablonu",
      "titlePlural": "Smazat šablony",
      "message": "Opravdu chcete smazat tuto šablonu? Tato akce je nevratná.",
      "messagePlural": "Opravdu chcete smazat vybrané šablony? Tato akce je nevratná.",
      "success": "Šablona byla úspěšně smazána",
      "error": "Šablonu se nepodařilo smazat"
    },
    "exportTemplate": "Export šablon",
    "exportDescription": "Zaškrtnutím šablony se exportují i navázané šablony",
    "exportSummaryTitle": "Náhled obsahu exportu",
    "exportWithRelatedLabel": "s navázanými šablonami",
    "exportOnlyThisLabel": "pouze tato šablona",
    "userDefinedField": {
      "addAggregationGroup": "Přidat agregační skupinu",
      "addGroup": "Pridať skupinu",
      "addItem": "Přidat položku",
      "editAggregationGroup": "Upravit agregační skupinu",
      "editGroup": "Upravit skupinu",
      "dataModelItem": "Položka datového modelu",
      "placeholder": {
        "group": "Pojmenujte skupinu",
        "value": "Zadejte hodnotu"
      },
      "type": {
        "none": "Žádné",
        "count": "Počet",
        "avg": "Průměr",
        "min": "Minimum",
        "max": "Maximum",
        "attribute": "Z modelu",
        "concatenate": "Spojení řetězců",
        "date": "Datum",
        "static": "Statická hodnota",
        "sum": "Suma",
        "time": "Čas"
      }
    },
    "versions": {
      "create": "Vytvořit novou verzi",
      "label": "Výběr verzí"
    },
    "filters": {
      "title": "Filtry",
      "activeFilters": "Aktivní filtry",
      "noActiveFilters": "Žádné aktivní filtry",
      "addFilter": "Přidat filtr",
      "editFilter": "Upravit filtr",
      "column": "Sloupec",
      "operator": "Operátor",
      "value": "Hodnota",
      "logicalOperator": "Logický operátor",
      "selectValue": "Vyberte hodnotu",
      "apply": "Potvrdit filtry",
      "savedFilters": "Uložené filtry",
      "noSavedFilters": "Žádné uložené filtry",
      "saveFilter": "Uložit filtr",
      "filterName": "Název filtru",
      "filterNamePlaceholder": "Zadejte název filtru",
      "setAsDefault": "Nastavit jako výchozí",
      "loadFilter": "Načíst filtr",
      "deleteFilter": "Smazat filtr",
      "filterSaved": "Filtr byl úspěšně uložen",
      "filterDeleted": "Filtr byl úspěšně smazán",
      "filterLoaded": "Filtr byl načten",
      "defaultFilter": "Výchozí",
      "updateFilter": "Aktualizovat filtr",
      "isBlank": "Prázdné",
      "isBlankEmpty": "Filtrovat prázdné",
      "isBlankNotEmpty": "Filtrovat neprázdné",
      "fromValue": "Od",
      "toValue": "Do",
      "advancedMode": "Rozšířené",
      "addValue": "Přidat hodnotu",
      "pressEnter": "Enter pro přidání"
    }
  },
  "datasources": {
    "title": "Datové zdroje",
    "createDataSource": "Vytvořit datový zdroj",
    "editDataSource": "Upravit datový zdroj",
    "loginPurposes": {
      "placeholder": "Vyberte z nabídky",
      "none": "Žádné",
      "user": "Uživatel",
      "serviceAccount": "Servisní účet",
      "both": "Uživatel a Servisní účet"
    },
    "deleteDatasourcesModal": {
      "title": "Smazat datový zdroj",
      "titlePlural": "Smazat datové zdroje",
      "message": "Opravdu chcete smazat datový zdroj?",
      "messagePlural": "Opravdu chcete smazat datové zdroje?",
      "submit": "Smazat",
      "success": "Datový zdroj byl úspěšně smazán",
      "error": "Datový zdroj se nepodařilo smazat"
    },
    "form": {
      "name": "Název",
      "namePlaceholder": "Zadejte název",
      "timeZone": "Časová zóna",
      "profile": "Profil",
      "profilePlaceholder": "Zadejte název profilu",
      "url": "URL",
      "urlPlaceholder": "Zadejte URL",
      "basicLoginPurpose": "Nedoménové mapování",
      "domainLoginPurpose": "Doménové mapování",
      "domain": "Doména",
      "domainPlaceholder": "Zadejte doménu",
      "googleLoginPurpose": "Google mapování",
      "microsoftLoginPurpose": "Microsoft mapování",
      "sections": {
        "general": "Základní nastavení",
        "loginMethods": "Přihlašovací metody",
        "accountMapping": "Mapování účtů"
      },
      "maxConcurrentConnections": "Max. počet souběžných připojení",
      "defaultUserMapping": "Uživatelské výchozí mapování",
      "useDefaultUserMapping": "Používat uživatelské výchozí mapování",
      "defaultUserMappingError": "Přidejte mapování nebo vypněte možnost \"{{useDefaultUserMapping}}\"",
      "serviceAccount": "Servisní účet",
      "map": "Namapovat",
      "unMap": "Odmapovat",
      "mappedAccount": "Namapovaný účet",
      "notMapped": "Nenamapováno",
      "userMapping": "Mapování uživatele",
      "userName": "Uživatelské jméno",
      "userNamePlaceholder": "Zadejte uživatelské jméno",
      "password": "Heslo",
      "passwordPlaceholder": "Zadejte heslo",
      "type": "Typ přihlášení"
    },
    "mapping": {
      "domain": "Doména",
      "google": "Google",
      "login": "Jméno a heslo",
      "microsoft": "Microsoft",
      "noMapping": "Žádné možnost mapování",
      "authWindowError": "Chyba při otevření okna pro přihlášení",
      "success": "Byl jste úspěšně namapován",
      "error": "Mapování se nepodařilo",
      "removeMappingTitle": "Zrušit mapování",
      "removeMappingConfirm": "Opravdu chcete zrušit uložené mapování?",
      "removeMappingSubmit": "Zrušit mapování",
      "removeMappingSuccess": "Mapování bylo úspěšně zrušeno",
      "removeMappingError": "Mapování se nepodařilo zrušit",
      "invalidMapping": "Uložené mapování k datovému zdroji již není platné. Namapujte se prosím znovu."
    },
    "users": {
      "edit": "Upravit mapování uživatele",
      "modal": {
        "title": "Odmapování uživatele",
        "delete": {
          "title": "Odmapování uživatele",
          "message": "Opravdu chcete odmapovat uživatele?",
          "submit": "Odmapovat",
          "success": "Uživatel byl úspěšně odmapován",
          "error": "Odmapování uživatele se nezdařilo"
        }
      }
    }
  },
  "tables": {
    "title": "Tabulky",
    "deleteConfirmation": "Opravdu chcete smazat vybrané tabulky? Tato akce je nevratná.",
    "modalAddtable": {
      "addColumn": "Přidat sloupec",
      "columnName": "Název sloupce",
      "editColumn": "Upravit sloupec",
      "error": {
        "missingColumns": "Tabulka musí mít alespoň jeden sloupec",
        "uniqueName": "Název tabulky musí být unikátní"
      },
      "tableName": "Název tabulky",
      "tableNamePlaceholder": "Zadejte název tabulky",
      "title": {
        "_": "Přidat tabulku",
        "create": "Přidat tabulku",
        "edit": "Upravit tabulku",
        "selectDataSource": "Vyberte datový zdroj",
        "selectTable": "Vyberte tabulku"
      },
      "sorting": {
        "label": "Řazení tabulek",
        "asc": "Od A do Z",
        "desc": "Od Z do A"
      },
      "unique": "Sloupec je unikátní"
    },
    "successfully": {
      "created": "Tabulky byly úspěšně vytvořeny",
      "deleted": "Tabulky byly úspěšně smazány",
      "updated": "Tabulky byly úspěšně upraveny"
    }
  },
  "notificationTemplates": {
    "form": {
      "addParameter": "Přidat parametr",
      "email": "Email notifikace",
      "insertParam": "Vložit parametr",
      "name": "Jméno notifikace",
      "parameter": "Název parametru",
      "parameterExists": "Tento parameter již existuje",
      "parameterRequired": "Název parametru je povinný pro přidání parametru",
      "push": "Push notifikace",
      "subject": "Předmět",
      "text": "Text notifikace",
      "web": "Notifikace v aplikaci",
      "description": "Popis",
      "title": "Název"
    },
    "confirmationModalForLeaving": {
      "title": "Opravdu chcete opustit tuto stránku?",
      "description": "Kliknutím na potvrzení odejdete ze stránky a ztratíte neuložená data."
    },
    "confirmationModalForRemoving": {
      "title": "Opravdu si přejete odstranit tuto notifikační šablonu?",
      "description": "Kliknutím na potvrzení bude šablona odstraněna."
    },
    "title": {
      "listOfTemplates": "Seznam notifikačních šablon",
      "newConditions": "Nové podmínky"
    }
  },
  "functions": {
    "title": "Funkce",
    "tooltips": {
      "noFunctions": "Žádné funkce"
    },
    "toasts": {
      "error": "Něco se nepovedlo",
      "errors": {
        "delete": "Chyba při mazání funkce",
        "edit": "Chyba při úpravě funkce",
        "add": "Chyba při přidávání funkce",
        "import": "Chyba při importu funkce"
      },
      "success": {
        "delete": "Funkce byla úspěšně smazána",
        "edit": "Funkce byla úspěšně upravena",
        "add": "Funkce byla úspěšně přidána",
        "import": "Funkce byla úspěšně importována"
      }
    },
    "addFunctionTranslation": {
      "title": "Přidat funkci",
      "buttons": {
        "add": "Přidat",
        "cancel": "Zrušit"
      }
    },
    "addFunctionModal": {
      "title": "Přidat funkci",
      "buttons": {
        "add": "Uložit",
        "cancel": "Zrušit",
        "addParameters": "Přidat parametry"
      },
      "fields": {
        "sections": {
          "basicInfo": "Základní údaje",
          "parameters": "Parametry funkce",
          "settings": "Ostatní nastavení"
        },
        "name": "Název",
        "id": "Helios ID funkce",
        "isCommon": "Je obecná",
        "isEntryFunction": "Položková",
        "dataSource": "Datový zdroj",
        "column": "Sloupec",
        "functionType": "Typ",
        "functionTypes": {
          "Heg": "Funkce",
          "HegWorkflow": "Workflow akce"
        },
        "skipEntriesWithError": "Přeskočit položky s chybou",
        "parentColumn": "Sloupec rodiče",
        "functionWorkflowCommentType": "Typ komentáře",
        "worflowCommentType": {
          "none": "Žádné",
          "optional": "Volitelné",
          "required": "Povinné"
        }
      }
    },
    "importFunctionModal": {
      "title": "Importovat funkci",
      "buttons": {
        "add": "Importovat",
        "cancel": "Zrušit",
        "addParameters": "Přidat parametry"
      },
      "fields": {
        "sections": {
          "basicInfo": "Základní údaje",
          "importSettings": "Nastavení importu"
        },
        "name": "Název",
        "nameTooltip": "Název funkce, pod kterým bude uložena ve Flowiu.",
        "column": "Sloupec",
        "functionType": "Typ",
        "id": "Helios ID funkce",
        "idTooltip": "Číslo akce (např. 1205493) z přehledu Funkce / Externí akce v Heliosu.",
        "isCommon": "Je obecná",
        "isCommonTooltip": "Pokud je zapnuto, funkce bude dostupná globálně. Pokud vypnuto, bude vázána na konkrétní datový zdroj.",
        "importCodeListTemplates": "Importovat číselníkové šablony",
        "importCodeListTemplatesHelp": "Platí pouze pro statické parametry typu Relation. Po zapnutí vyberte modul, do kterého budou nové šablony zařazeny.",
        "module": "Modul",
        "isEntryFunction": "Položková",
        "parentColumn": "Sloupec rodiče",
        "dataSource": "Datový zdroj",
        "paramjson": "Parametr JSON",
        "skipEntriesWithError": "Přeskočit položky s chybou",
        "functionWorkflowCommentType": "Typ komentáře",
        "worflowCommentType": {
          "none": "Žádné",
          "optional": "Volitelné",
          "required": "Povinné"
        }
      }
    },
    "addFunctionParametersModal": {
      "title": "Detail parametru",
      "buttons": {
        "add": "Přidat",
        "addOption": "Přidat možnost",
        "cancel": "Zrušit",
        "addKeyValue": "Přidat",
        "select": "Vybrat",
        "selectOverviewTemplate": "Vybrat přehledovou šablonu",
        "update": "Aktualizovat"
      },
      "fields": {
        "name": "Název",
        "type": "Typ",
        "label": "Popisek",
        "maxCharCount": "Maximální znaky (pouze pro textové pole/textovou oblast)",
        "overviewSelect": "Číselník",
        "key": "Klíč",
        "order": "Pořadí parametru",
        "value": "Hodnota",
        "isRequired": "Je povinný",
        "isMultiSelect": "Umožnit výběr více záznamů",
        "options": "Možnosti"
      },
      "types": {
        "Text": "Text",
        "Relation": "Výběr z přehledu",
        "Checkbox": "Zaškrtávací pole",
        "Date": "Datum",
        "Time": "Čas",
        "DateTime": "Datum a čas",
        "Radio": "Výběr jedné možnosti",
        "Password": "Heslo",
        "File": "Soubor",
        "MultiSelect": "Statický výběr"
      }
    },
    "editFunctionModal": {
      "title": "Upravit detail řádku",
      "buttons": {
        "add": "Přidat",
        "cancel": "Zrušit",
        "addParameters": "Přidat parametry"
      },
      "fields": {
        "id": "Helios ID funkce",
        "name": "Název",
        "column": "Sloupec",
        "type": "Typ",
        "isCommon": "Je obecná",
        "isEntryFunction": "Položková",
        "skipEntriesWithError": "Přeskočit položky s chybou",
        "parentColumn": "Sloupec rodiče",
        "dataSource": "Datový zdroj",
        "functionWorkflowCommentType": "Typ komentáře",
        "worflowCommentType": {
          "none": "Žádné",
          "optional": "Volitelné",
          "required": "Povinné"
        }
      }
    },
    "deleteFunctionsModal": {
      "title": "Smazání funkce",
      "description": "Jste si jisti, že chcete tento záznam smazat? Tato akce je nevratná.",
      "buttons": {
        "delete": "Smazat",
        "cancel": "Zrušit"
      }
    }
  },
  "copyInRow": {
    "copy": "Kopírovat",
    "copyInRow": "Kopírovat v řádku"
  },
  "importTemplates": {
    "classFolders": "Čísla tříd a pořadačů",
    "notificationTemplates": "Notifikační šablony",
    "runImport": "Spustit import",
    "templateFunctions": "Funkce šablony",
    "classFoldersModal": {
      "classIdExists": "Třída s tímto číslem již existuje",
      "title": "Editovat číslo třídy a pořadače"
    },
    "notificationTemplatesModal": {
      "new": "Nová notifikační šablona",
      "title": "Editovat notifikační šablonu",
      "original": "Původní notifikační šablona"
    },
    "importTemplateModal": {
      "exportedTemplate": "Exportovaná šablona",
      "successfulyImported": "Šablona byla úspěšně importována",
      "title": "Importovat šablonu",
      "uploadTemplate": "Nahrajte šablonu"
    },
    "templateFunctionsModal": {
      "new": "Nová funkce šablony",
      "title": "Editovat funkci šablony",
      "original": "Původní funkce šablony"
    },
    "importMode": {
      "label": "Režim importu",
      "newVersion": "Nová verze",
      "freshCopy": "Nová kopie",
      "newVersionDesc": {
        "exists": "Tato šablona již existuje. Importováním bude archivována aktuální verze.",
        "notExists": "Tato šablona v tomto prostředí ještě neexistuje. Bude vytvořena."
      },
      "freshCopyDesc": {
        "exists": "Tato šablona již existuje. Bude vytvořena nová samostatná kopie — stávající šablona zůstane beze změny.",
        "notExists": "Tato šablona ještě neexistuje. Bude vytvořena samostatná kopie."
      }
    },
    "warnings": {
      "title": "Varování",
      "dismiss": "Zavřít",
      "browseTargetNotInBundle": "Odkaz procházení mimo balíček",
      "linkTargetNotInBundle": "Odkaz odkazu mimo balíček",
      "functionNotAutoResolved": "Funkce vyžaduje ruční mapování",
      "realTimeFunctionOrphaned": "Odkaz na real-time funkci bude odstraněn"
    },
    "autoResolved": "Automaticky vyřešeno",
    "state": {
      "failed": "Selhalo"
    }
  },
  "listing": {
    "errorLoadData": "Chyba při načítání dat z Heliosu, zkuste to prosím znovu později",
    "delete": {
      "confirm": "Opravdu chcete smazat tento záznam?"
    },
    "exportModal": {
      "title": "Exportovat šablonu {{name}}",
      "titleDetail": "Exportovat položkovou šablonu {{name}}",
      "fileName": "Název souboru",
      "fileType": "Typ souboru",
      "pagesToExport": "Počet stránek k exportu (1-{{count}})",
      "exportAllPages": "Exportovat všechny stránky",
      "success": "Tabulka byla úspěšně exportována",
      "tableType": "Typ tabulky",
      "tableTypes": {
        "table": "Položky",
        "tableDetail": "Detail a položky"
      }
    },
    "navigateError": "Nastala chyba při otevírání záznamu",
    "success": {
      "deleteRow": "Záznam byl úspěšně smazán",
      "editRow": "Záznam byl úspěšně upraven",
      "createRow": "Záznam byl úspěšně vytvořen"
    },
    "error": {
      "editRow": "Záznam {{rowId}} se nepodařilo uložit"
    },
    "calendar": {
      "table": "Tabulka",
      "calendar": "Kalendář",
      "view": "Zobrazit",
      "edit": "Upravit",
      "delete": "Smazat",
      "noDetailTemplate": "Kalendář nemá přiřazenou detailní šablonu, proto nelze přidávat záznamy.",
      "noPermission": "Nemáte oprávnění přidávat záznamy v tomto kalendáři."
    }
  }
}
